export default __webpack_public_path__ + "static/media/NoirPro-Medium.715c4044.woff2";